<template>
  <transition name="modal">
    <div class="modal-mask white">
      <div class="modal-wrapper" style="position:fixed">
        <div style="position: absolute;top: 50%;left: 0;right: 0">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
export default {
  components: {
    SyncLoader
  },
  mounted: function() {
    $("body").addClass("modal-open");
  },
  destroyed: function() {
    $("body").removeClass("modal-open");
  }
};
</script>

<style scoped>
</style>